import * as React from 'react';

import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { NoteContent } from 'view/layout/note-content';
import { h600, h700 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { DocumentTitle } from '@atlassian/help-center-common-component/document-title';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { CompleteSignupForm } from '../complete-signup-form';
import commonMessages from '../messages';
import messages from './messages';

interface CompleteSignupStatelessProps {
    email: string;
    isLoading: boolean;
    helpCenterName: string;
}

export class CompleteSignupStateless extends React.Component<CompleteSignupStatelessProps & InjectedIntlProps> {
    render() {
        const { intl, isLoading, email, helpCenterName } = this.props;

        return (
            <DocumentTitle title={intl.formatMessage(commonMessages.documentTitle)}>
                <NoteContent isLoading={isLoading}>
                    <FireScreenEventOnMount />
                    <Title>{helpCenterName}</Title>
                    <SubTitle>{intl.formatMessage(messages.signUpToContinue)}</SubTitle>
                    <CompleteSignupForm email={email} />
                </NoteContent>
            </DocumentTitle>
        );
    }
}

export default injectIntl(CompleteSignupStateless);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.div`
    ${h700};
    margin-bottom: ${token('space.300', '24px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const SubTitle = styled.div`
    ${h600};
    margin-bottom: ${token('space.050', '4px')};
`;
